package com.wintermar.inspection.feature.domain.model.auth

data class UserModel(
    val userId: String = "",
    val fullName: String = "",
    val listAccess: List<String> = listOf()
)
